import React, { FC, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import findArtistById, {
  findArtistByIdResponse,
  findArtistByIdVariables,
} from 'core/graphql/queries/findArtistById';
import findArtistEarning, {
  findArtistDetailsResponse,
  findArtistDetailsVariables,
} from 'core/graphql/queries/findArtistTotalEarning';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Star from "../pictures/featureStar.svg"
import { RouteComponentProps, useHistory } from 'react-router-dom';
import ArtistAlbumList from 'components/ArtistAlbumList';
import MusicPageLayout from 'containers/MusicPageLayout';
import FlagCountTracker from 'containers/FlagCountTracker';
import TextLink from 'components/@ui/TextLink';
import ContentFlags from 'containers/ContentFlags';
import { Box } from '@material-ui/core';
import ArtistActionMenu from '../components/ArtistActionMenu';
import backArrow from "../pictures/backArrow.svg"
import ConfirmAction from 'stores/ConfirmAction';
import { useApolloClient } from '@apollo/client';
import ArtistActionMenuManager from 'stores/ArtistActionMenu';
import ConfirmActionPopUp from '../components/@ui/ConfirmAction';
import { observer } from 'mobx-react-lite';
import Avatar from "../pictures/dummyAvatar.svg"
import MoreButton from '../components/@ui/MoreButton';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { MenuItem, ListItemText } from '@material-ui/core';



interface ArtistProps extends RouteComponentProps<{ id: string }> { }

const ArtistPage: FC<ArtistProps> = ({ match }) => {

  const QueryMultiple = () => {
    const res1 = useQuery<findArtistByIdResponse>(findArtistById, { variables: { artistId: match.params.id } });
    const res2 = useQuery<findArtistDetailsResponse>(findArtistEarning, { variables: { id: match.params.id } });
    return [res1, res2];
  }

  const [
    { loading: loading1, data: data1 },
    { loading: loading2, data: data2 },


  ] = QueryMultiple()

  // console.log(data2?.findArtistTotalEarning?.totalEarnInDollar, "hello")

  const history = useHistory();

  const useStyles = makeStyles<Theme>((theme) => ({
    banner: {
      backgroundImage: `url(${data1?.artist.bannerImage})`,
      backgroundPosition: 'center',
      backgroundSize: '100%',
      backgroundRepeat: "no-repeat",
      width: '100%',
      height: "200px",
      position: "relative",
    },
    bannerImage: {
      width: "100%"
    },
    avatar: {
      width: '100px',
      height: '100px',
      position: "relative",
      top: "-15px",
      borderRadius: '50%',
    },
    artistName: {
      fontSize: "24px",
      margin: '0',
      marginTop: "10px",
      // lineHeight: '0.3'
    },
    featured: {
      color: "#FD4060",
      fontSize: "14px"
    },
    description: {
      fontSize: '14px',
      fontWeight: 300,
      lineHeight: '30px',
    },
    albumCard: {
      height: "150px",
      width: "150px",
      borderRadius: "2px",
      cursor: 'pointer',
    },
    backBtn: {
      position: 'absolute',
      top: "3.4%",
      left: "4%",
      display: "flex",
      gap: "0.3rem",
      alignItems: "center",
      cursor: 'pointer',
    },
    acceptBtn: {
      backgroundColor: '#0ED3BF',
      color: "white",
      borderRadius: '4px',
      padding: '8px 15px',
      fontSize: '16px'
    },
    declineBtn: {
      backgroundColor: 'transparent',
      color: "white",
      border: '1px solid white',
      borderRadius: '4px',
      padding: '8px 15px',
      fontSize: '16px'
    },
    artistContainer: {
      display: "flex",
      gap: "1rem",
      paddingRight: "20px"
    },
    icon: { fill: theme.palette.primary.main },
  }));

  const classes = useStyles()
  const client = useApolloClient();
  let id = window.location.pathname.split('/')[2]

  const [ArtistActionMenuStore] = useState(
    new ArtistActionMenuManager(client, id, '')
  );

  const [confirmActionStore] = useState(new ConfirmAction());


  const hash = useMemo(() => {
    return history.location.hash;
  }, [history.location]);

  const handleClick = (id: any) => {
    history.push(`/album/${id}`)
  }

  const goBack = () => {
    history.goBack()
  }
  const handleApprove = (artist: any) => {
    confirmActionStore.setConfirmOpen(true);
    confirmActionStore.setTitle('Approve');
    confirmActionStore.setMessage(
      `Are you sure you want to approve ${artist.displayName}'s  status?`
    );
    ArtistActionMenuStore.setActionToRun(ArtistActionMenuStore.approveArtist);
    console.log(ArtistActionMenuStore, 'new')
  };

  const handleReject = (artist: any) => {
    confirmActionStore.setTitle('Reject Approval');
    confirmActionStore.setMessage(
      `Are you sure you want to reject the approval of ${artist.displayName}?`
    );
    ArtistActionMenuStore.setActionToRun(ArtistActionMenuStore.rejectArtist);
    confirmActionStore.setConfirmOpen(true);
  };

  const handleFeature = (artist: any) => {
    confirmActionStore.setTitle('Feature');
    confirmActionStore.setMessage(
      `Are you sure you want to feature the Artist: ${artist.displayName}?`
    );
    ArtistActionMenuStore.setActionToRun(ArtistActionMenuStore.featureArtist);
    confirmActionStore.setConfirmOpen(true);
  };

  const handleRemoveFeature = (artist: any) => {
    confirmActionStore.setTitle('Remove from Featured');
    confirmActionStore.setMessage(
      `Are you sure you want to remove ${artist.displayName} from featured ?`
    );
    ArtistActionMenuStore.setActionToRun(ArtistActionMenuStore.unfeatureArtist);
    confirmActionStore.setConfirmOpen(true);
  };

  const handleSuspend = (artist: any) => {
    confirmActionStore.setTitle('Suspend');
    confirmActionStore.setMessage(
      `Are you sure you want to suspend ${artist.displayName}?`
    );
    ArtistActionMenuStore.setActionToRun(ArtistActionMenuStore.suspendArtist);
    confirmActionStore.setConfirmOpen(true);
  };

  const handleEnable = (artist: any) => {
    confirmActionStore.setTitle('Enable');
    confirmActionStore.setMessage(
      `Are you sure you want to enalbe ${artist.displayName}?`
    );
    ArtistActionMenuStore.setActionToRun(ArtistActionMenuStore.enableArtist);
    confirmActionStore.setConfirmOpen(true);
  };
  const handleDisable = (artist: any) => {
    confirmActionStore.setTitle('Disable');
    confirmActionStore.setMessage(
      `Are you sure you want to disable ${artist.displayName}?`
    );
    ArtistActionMenuStore.setActionToRun(ArtistActionMenuStore.disableArtist);
    confirmActionStore.setConfirmOpen(true);
  };


  return (
    <>
      <Box className={classes.banner}>
        <div className={classes.backBtn} onClick={goBack}>
          <img src={backArrow} />
          <h2>
            Back
          </h2>
        </div>
      </Box>
      <Box padding="0px 12px 0 80px">

        <Box display="flex" alignItems="center" style={{ gap: "1rem" }}>
          <div className={classes.avatar}>
            <img src={data1?.artist.image === null ? Avatar : data1?.artist.image} style={{ width: "100%", height: "100%", borderRadius: '50%' }} />
          </div>
          {data1?.artist?.status === "PENDING" ? <> <h2 className={classes.artistName}>
            {data1?.artist.displayName}
          </h2>
            <div style={{ display: 'flex', justifyContent: "flex-end", width: '100%' }}>
              {data1?.artist?.status === "PENDING" ? <> <div className={classes.artistContainer}>
                <h2> Status -  Pending </h2>
                <button style={{ cursor: "pointer" }} className={classes.acceptBtn} onClick={() => {
                  handleApprove(data1?.artist)

                }}>
                  Accept
                </button>
                <button style={{ cursor: "pointer" }} className={classes.declineBtn} onClick={() => {
                  handleReject(data1?.artist)
                }}>
                  Decline
                </button>
              </div></> : " "}
            </div>
          </> : <div style={{ display: 'flex', gap: '0.5rem' }}>
            <div>
              <h2 className={classes.artistName}>
                {data1?.artist.displayName}
              </h2>

              <p className={classes.featured}>
                {data1?.artist.isFeatured ? <>
                  <span style={{ display: "flex", gap: '0.3rem' }}>
                    <img src={Star} />
                    Featured Artist
                  </span>
                </> : ""}
              </p>
            </div>
            <div>
              <MoreButton dropDownIcon={<MoreHorizIcon className={classes.icon} />}>
                {data1?.artist.isFeatured && data1?.artist?.status === 'APPROVED' ? (
                  <MenuItem onClick={() => handleRemoveFeature(data1?.artist)}>
                    <ListItemText

                      style={{ color: '#02172A' }}
                      primary="Remove from Featured"
                    />
                  </MenuItem>
                ) : (
                  data1?.artist?.status === 'APPROVED' && (
                    <MenuItem onClick={() => handleFeature(data1?.artist)}>
                      <ListItemText style={{ color: '#02172A' }} primary="Feature" />
                    </MenuItem>
                  )
                )}
                {data1?.artist?.status === 'APPROVED' && (
                  <MenuItem onClick={() => handleSuspend(data1?.artist)}>
                    <ListItemText style={{ color: '#02172A' }} primary="Suspend" />
                  </MenuItem>
                )}
                {data1?.artist?.isActive === false ? (
                  <MenuItem onClick={() => handleEnable(data1?.artist)}>
                    <ListItemText style={{ color: '#02172A' }} primary="Enable" />
                  </MenuItem>
                ) : (
                  <MenuItem onClick={() => handleDisable(data1?.artist)}>
                    <ListItemText style={{ color: '#02172A' }} primary="Disable" />
                  </MenuItem>
                )
                }
              </MoreButton>
            </div>
          </div>}
        </Box>
        {data1?.artist?.status === "PENDING" ?
          "" : <>
            <div className={classes.description}>
              {data1?.artist.description}
            </div>
            <div style={{ margin: '50px 0' }}>
              <h2 style={{ fontSize: "24px", lineHeight: '10px' }}>
                Artist's Earnings :
              </h2>
              <p style={{ fontSize: "18px", }}>
                $ {data2?.findArtistTotalEarning?.totalEarnInDollar}
              </p>
            </div>
            <Box>
              <h2 style={{ fontSize: "24px" }}>
                Albums
                <span style={{ marginLeft: "10px", fontSize: "12px", fontWeight: 300 }}>
                  {
                    (() => {
                      const albums = data1?.artist?.albums || [];

                      const filtered = albums
                        .filter((a: any) => a?.disabled !== true)
                        .filter((a: any) => a?.status === 'APPROVED' || a?.status === undefined)
                        .filter((a: any) => a?.artistApproved === undefined || a?.artistApproved === true)
                        .filter((a: any) => (a?.songs?.length ?? 0) > 0);

                      // Deduplicate by title (case-insensitive), keeping the album with most songs.
                      const byTitle = new Map<string, any>();
                      for (const album of filtered) {
                        const key = String(album?.title || '').trim().toLowerCase();
                        if (!key) continue;
                        const prev = byTitle.get(key);
                        const prevCount = prev?.songs?.length ?? 0;
                        const nextCount = album?.songs?.length ?? 0;
                        if (!prev || nextCount > prevCount) {
                          byTitle.set(key, album);
                        }
                      }

                      return Array.from(byTitle.values()).length;
                    })()
                  } albums
                </span>
              </h2>
              {
                (() => {
                  const albums = data1?.artist?.albums || [];

                  const filtered = albums
                    .filter((a: any) => a?.disabled !== true)
                    .filter((a: any) => a?.status === 'APPROVED' || a?.status === undefined)
                    .filter((a: any) => a?.artistApproved === undefined || a?.artistApproved === true)
                    .filter((a: any) => (a?.songs?.length ?? 0) > 0);

                  const byTitle = new Map<string, any>();
                  for (const album of filtered) {
                    const key = String(album?.title || '').trim().toLowerCase();
                    if (!key) continue;
                    const prev = byTitle.get(key);
                    const prevCount = prev?.songs?.length ?? 0;
                    const nextCount = album?.songs?.length ?? 0;
                    if (!prev || nextCount > prevCount) {
                      byTitle.set(key, album);
                    }
                  }

                  return Array.from(byTitle.values()).map((album: any) => (
                    <div key={album?._id || album?.title} style={{ display: 'inline-flex', margin: "0 10px" }}>
                      <div onClick={() => handleClick(album._id)}>
                        <img src={album.imageUrl} className={classes.albumCard} />
                        <p style={{ fontSize: '14px' }}>
                          {album.title}
                        </p>
                      </div>
                    </div>
                  ));
                })()
              }
            </Box>
          </>}
      </Box>
      <ConfirmActionPopUp
        context={confirmActionStore}
        actionOnConfirm={ArtistActionMenuStore.actionToRun!}
      />
    </>
  );
};

export default observer(ArtistPage);
